













import { Vue, Component } from 'vue-property-decorator'
import Logo from '@/components/layout/Logo.vue'
import { SessionStore } from '@/store/session'
import { comfirmLogout } from '@/services/session/auth'

@Component({
  components: { Logo }
})
export default class Topbar extends Vue {
  get name() {
    return SessionStore.user.username
  }

  handleLogout() {
    comfirmLogout()
  }
}
